/** Remembers join credentials per session code so a reloaded or reconnected phone keeps its seat. */
import { storageKey } from "@shared/brand";
import type { ClientKind } from "@shared/protocol";

export interface SavedJoin {
  code: string;
  token: string;
  playerId: string;
  kind: ClientKind;
  wsPath: string;
  name: string;
  roleId: string | null;
  savedAt: number;
}

const prefix = `${storageKey("join")}.`;

export function loadJoin(code: string): SavedJoin | null {
  try {
    const raw = localStorage.getItem(prefix + code.toUpperCase());
    if (!raw) return null;
    const j = JSON.parse(raw) as SavedJoin;
    // Player tokens live 24 h.
    if (Date.now() - j.savedAt > 23 * 3600 * 1000) return null;
    return j;
  } catch {
    return null;
  }
}

export function saveJoin(j: SavedJoin): void {
  try {
    localStorage.setItem(prefix + j.code.toUpperCase(), JSON.stringify(j));
  } catch {
    /* ignore */
  }
}

export function clearJoin(code: string): void {
  try {
    localStorage.removeItem(prefix + code.toUpperCase());
  } catch {
    /* ignore */
  }
}
